import(/* webpackMode: "eager" */ "/home/runner/work/peazy-dev/peazy-dev/ui/app.bookpeazy.com/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/peazy-dev/peazy-dev/ui/app.bookpeazy.com/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/peazy-dev/peazy-dev/ui/app.bookpeazy.com/src/images/logo.svg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/peazy-dev/peazy-dev/ui/app.bookpeazy.com/src/images/svg/green-white-check.svg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/peazy-dev/peazy-dev/ui/app.bookpeazy.com/src/images/svg/signup.svg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/peazy-dev/peazy-dev/ui/app.bookpeazy.com/src/images/svg/user.svg");
